/* Reseñas F&NT — lógica de sections/fnt-resenas.liquid (separada el 15 oct 2026).
   Lee de Klaviyo las reseñas publicadas y verificadas y deja las de este producto
   y las de los IDs del metacampo custom.resenas_extra_ids (data-rv-meta: productIds).
   Reseña destacada (17 oct 2026): la del metacampo custom.resena_destacada_id
   (data-rv-meta: featuredId); si está vacío, la regla de 5★ con el texto más largo.
   Fotos (17 oct 2026): la ruta llega sin dominio; se completa con MEDIA y la miniatura es THUMB. */
(function () {
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var MONTHS_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var API = 'https://fast.a.klaviyo.com/client/reviews/';
  var REVISION = '2026-07-15';
  var cache = {};
  var MEDIA = 'https://klaviyo.s3.amazonaws.com/reviews/images/';
  var THUMB = 'https://reviews-media.services.klaviyo.com/abc/width:400/plain/';

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  // Primera letra en mayúscula (muchos comentarios llegan en minúsculas)
  function capFirst(text) {
    var t = String(text || '').trim();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  // Klaviyo ya manda "Nombre I."; si llegara un nombre completo, se recorta igual
  function shortName(full) {
    var words = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return 'Cliente';
    var name = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    if (words[1]) name += ' ' + words[1].charAt(0).toUpperCase() + '.';
    return name;
  }

  // Fecha sin desfase de zona horaria (se leen año, mes y día del texto)
  function dateParts(value) {
    var m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return null;
    return { y: +m[1], m: +m[2] - 1, d: +m[3] };
  }

  function longDate(p) {
    return p ? p.d + ' de ' + MONTHS[p.m] + ' de ' + p.y : '';
  }

  function shortDate(p) {
    return p ? p.d + ' ' + MONTHS_SHORT[p.m] + ' ' + p.y : '';
  }

  function starsHtml(n) {
    var full = Math.round(n);
    var out = '';
    for (var i = 1; i <= 5; i++) out += '<span class="' + (i <= full ? 'on' : 'off') + '">★</span>';
    return out;
  }

  // Las fotos pueden llegar como texto o como objeto con url; Klaviyo manda la ruta sin dominio
  function imageList(images) {
    if (!Array.isArray(images)) return [];
    return images.map(function (img) {
      var src = typeof img === 'string' ? img : (img && (img.url || img.src || img.original || img.thumbnail) || '');
      src = String(src || '').trim();
      if (!src) return '';
      return /^https?:\/\//.test(src) ? src : MEDIA + src.replace(/^\/+/, '');
    }).filter(Boolean);
  }

  // Miniaturas que abren la foto completa
  function photosHtml(r) {
    if (!r.images.length) return '';
    return '<div class="fnt-rv__photos">' + r.images.slice(0, 4).map(function (src) {
      var thumb = src.indexOf(MEDIA) === 0 ? THUMB + src : src;
      return '<a href="' + esc(src) + '" target="_blank" rel="noopener"><img src="' + esc(thumb) + '" alt="Foto de ' + esc(shortName(r.name)) + '" loading="lazy" width="112" height="112"></a>';
    }).join('') + '</div>';
  }

  // Pide las publicadas; verificadas y producto se filtran aquí (el filtro verified de Klaviyo llega con atraso, 17 oct)
  function fetchReviews(company, productIds) {
    if (!cache[company]) {
      var filter = 'equals(status,"published")';
      var url = API + '?company_id=' + encodeURIComponent(company) +
        '&filter=' + encodeURIComponent(filter) + '&page%5Bsize%5D=100&sort=-created';
      var all = [];

      var page = function (u, n) {
        return fetch(u, { headers: { revision: REVISION, accept: 'application/vnd.api+json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('Klaviyo ' + r.status);
            return r.json();
          })
          .then(function (data) {
            all = all.concat(data.data || []);
            var next = data.links && data.links.next;
            if (next && n < 5) return page(String(next).replace('https://a.klaviyo.com/', 'https://fast.a.klaviyo.com/'), n + 1);
            return all;
          });
      };

      cache[company] = page(url, 1);
    }

    var ids = productIds.map(function (x) { return String(x).trim(); }).filter(Boolean);

    return cache[company].then(function (list) {
      return list.filter(function (r) {
        var a = r.attributes || {};
        if (a.verified !== true || a.review_type === 'question' || a.review_type === 'store') return false;
        var ext = a.product && a.product.external_id != null ? String(a.product.external_id) : '';
        if (ext) return ids.indexOf(ext) > -1;
        // Sin external_id: el ID del producto es la última parte de $shopify:::$default:::<id>
        var item = r.relationships && r.relationships.item && r.relationships.item.data;
        var id = item && String(item.id || '');
        if (!id) return false;
        return ids.indexOf(id.split(':::').pop()) > -1;
      });
    });
  }

  function render(root) {
    if (root.dataset.rvReady) return;
    root.dataset.rvReady = 'true';

    var meta = {};
    try { meta = JSON.parse(root.querySelector('[data-rv-meta]').textContent); } catch (e) {}
    var ids = Array.isArray(meta.productIds) && meta.productIds.length ? meta.productIds : [meta.productId];
    if (!meta.company || !ids[0]) { root.hidden = true; return; }

    fetchReviews(meta.company, ids)
      .then(function (list) { paint(root, meta, list); })
      .catch(function (err) {
        console.warn('[F&NT reseñas]', err);
        root.hidden = true;
      });
  }

  function paint(root, meta, list) {
    var perPage = meta.perPage || 4;

    var items = list.map(function (r) {
      var a = r.attributes || {};
      var reply = a.public_reply && (a.public_reply.content || '');
      return {
        id: String(r.id),
        name: a.author,
        stars: Number(a.rating) || 0,
        text: capFirst(a.content),
        reply: String(reply || '').trim(),
        date: a.created,
        variant: '',
        images: imageList(a.images)
      };
    }).filter(function (r) { return r.stars > 0; });

    if (!items.length) { root.hidden = true; return; }
    items.forEach(function (r) { r.parts = dateParts(r.date); r.time = r.parts ? Date.UTC(r.parts.y, r.parts.m, r.parts.d) : 0; });

    // ---------- Resumen ----------
    var total = items.length;
    var sum = items.reduce(function (a, r) { return a + r.stars; }, 0);
    var avg = Math.round((sum / total) * 10) / 10;
    root.querySelector('[data-rv-avg]').textContent = avg.toFixed(1);
    root.querySelector('[data-rv-stars]').style.setProperty('--fnt-fill', (avg / 5) * 100 + '%');

    var reviews = items.filter(function (r) { return r.text; });
    var counts = [0, 0, 0, 0, 0, 0];
    items.forEach(function (r) { counts[Math.min(5, Math.max(1, Math.round(r.stars)))]++; });

    root.querySelector('[data-rv-based]').textContent =
      total + (total === 1 ? ' calificación' : ' calificaciones') +
      (reviews.length ? ' · ' + reviews.length + (reviews.length === 1 ? ' reseña' : ' reseñas') : '');

    var bars = '';
    for (var s = 5; s >= 1; s--) {
      var pct = Math.round((counts[s] / total) * 100);
      bars += '<div class="fnt-rv__bar"><span>' + s + ' ★</span><i style="--w:' + pct + '%"></i><span>' + counts[s] + '</span></div>';
    }
    root.querySelector('[data-rv-bars]').innerHTML = bars;

    if (total >= 3) {
      var good = Math.round(((counts[4] + counts[5]) / total) * 100);
      root.querySelector('[data-rv-kpi-num]').textContent = good + '%';
      root.querySelector('[data-rv-kpi]').hidden = false;
    }

    if (!reviews.length) {
      root.querySelector('[data-rv-layout]').classList.add('is-compact');
      return;
    }

    root.querySelector('[data-rv-main]').hidden = false;
    reviews.sort(function (a, b) { return b.time - a.time; });

    // ---------- Reseña destacada ----------
    // La fijada en custom.resena_destacada_id; si no hay, desde 3 comentarios la de 5★ más completa.
    // El estado Destacada de Klaviyo es solo para el inicio (FNT_klaviyo §7).
    var pool = reviews;
    var pinId = String(meta.featuredId || '').trim();
    var best = pinId ? reviews.filter(function (r) { return r.id === pinId; })[0] : null;
    if (!best && reviews.length >= 3) {
      best = reviews
        .filter(function (r) { return r.stars === 5 && r.text.length >= 40; })
        .sort(function (a, b) { return b.text.length - a.text.length; })[0];
    }
    if (best) {
      var fig = root.querySelector('[data-rv-featured]');
      fig.innerHTML =
        '<span class="fnt-rv__featured-label">Reseña destacada</span>' +
        '<blockquote class="fnt-rv__featured-quote">“' + esc(best.text.replace(/\s+/g, ' ')) + '”</blockquote>' +
        photosHtml(best) +
        '<div class="fnt-rv__meta">' +
          '<span class="fnt-rv__item-stars" aria-label="' + best.stars + ' de 5 estrellas">' + starsHtml(best.stars) + '</span>' +
          '<strong class="fnt-rv__name">' + esc(shortName(best.name)) + '</strong>' +
          '<span class="fnt-rv__badge">✔ Compra verificada</span>' +
          '<span class="fnt-rv__date"><span class="fnt-rv__date-long">' + longDate(best.parts) + '</span><span class="fnt-rv__date-short">' + shortDate(best.parts) + '</span></span>' +
        '</div>' +
        (best.reply ? '<div class="fnt-rv__reply"><strong>Respuesta de F&amp;NT</strong>' + esc(best.reply) + '</div>' : '');
      fig.hidden = false;
      pool = reviews.filter(function (r) { return r !== best; });
    }

    // ---------- Filtros y orden ----------
    var state = { filter: 'all', sort: 'recent', page: 1 };
    var hasReplies = pool.some(function (r) { return r.reply; });
    var hasPhotos = pool.some(function (r) { return r.images.length; });
    var filters = [
      { id: 'all', label: 'Todas', test: function () { return true; } },
      { id: '5', label: '5 ★', test: function (r) { return Math.round(r.stars) === 5; } },
      { id: '4', label: '4 ★', test: function (r) { return Math.round(r.stars) === 4; } },
      { id: 'low', label: '3 ★ o menos', test: function (r) { return Math.round(r.stars) <= 3; } }
    ];
    if (hasPhotos) filters.push({ id: 'photo', label: 'Con foto', test: function (r) { return r.images.length > 0; } });
    if (hasReplies) filters.push({ id: 'reply', label: 'Con respuesta', test: function (r) { return !!r.reply; } });

    var tools = root.querySelector('[data-rv-tools]');
    var chipsWrap = root.querySelector('[data-rv-chips]');
    if (reviews.length > 10) {
      tools.hidden = false;
      chipsWrap.innerHTML = filters.map(function (f) {
        var n = pool.filter(f.test).length;
        if (f.id !== 'all' && !n) return '';
        return '<button type="button" class="fnt-rv__chip" data-rv-filter="' + f.id + '" aria-pressed="' + (f.id === 'all') + '">' +
          esc(f.label) + (f.id === 'all' ? ' (' + n + ')' : '') + '</button>';
      }).join('');
      chipsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rv-filter]');
        if (!btn) return;
        state.filter = btn.dataset.rvFilter;
        state.page = 1;
        chipsWrap.querySelectorAll('[data-rv-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        draw(false);
      });
      root.querySelector('[data-rv-sort]').addEventListener('change', function (e) {
        state.sort = e.target.value;
        state.page = 1;
        draw(false);
      });
    }

    var list = root.querySelector('[data-rv-list]');
    var pages = root.querySelector('[data-rv-pages]');
    var empty = root.querySelector('[data-rv-empty]');

    function itemHtml(r) {
      var photos = photosHtml(r);
      return (
        '<li class="fnt-rv__item">' +
          '<div class="fnt-rv__item-top">' +
            '<span class="fnt-rv__item-stars" aria-label="' + r.stars + ' de 5 estrellas">' + starsHtml(r.stars) + '</span>' +
            '<span class="fnt-rv__date"><span class="fnt-rv__date-long">' + longDate(r.parts) + '</span><span class="fnt-rv__date-short">' + shortDate(r.parts) + '</span></span>' +
          '</div>' +
          '<p class="fnt-rv__text">' + esc(r.text) + '</p>' +
          '<button type="button" class="fnt-rv__readmore" hidden>Leer más</button>' +
          photos +
          '<div class="fnt-rv__meta">' +
            '<strong class="fnt-rv__name">' + esc(shortName(r.name)) + '</strong>' +
            '<span class="fnt-rv__badge">✔ <span class="fnt-rv__badge-long">Compra verificada</span><span class="fnt-rv__badge-short">Verificada</span></span>' +
            (r.variant ? '<span class="fnt-rv__variant">' + esc(r.variant) + '</span>' : '') +
          '</div>' +
          (r.reply ? '<div class="fnt-rv__reply"><strong>Respuesta de F&amp;NT</strong>' + esc(r.reply) + '</div>' : '') +
        '</li>'
      );
    }

    function pageButtons(current, count) {
      var nums = [];
      for (var i = 1; i <= count; i++) {
        if (i === 1 || i === count || Math.abs(i - current) <= 1) nums.push(i);
        else if (nums[nums.length - 1] !== '…') nums.push('…');
      }
      var html = '<button type="button" class="fnt-rv__page" data-rv-page="' + (current - 1) + '"' + (current === 1 ? ' disabled' : '') + ' aria-label="Página anterior">‹</button>';
      nums.forEach(function (n) {
        html += n === '…'
          ? '<span class="fnt-rv__page fnt-rv__page--gap">…</span>'
          : '<button type="button" class="fnt-rv__page" data-rv-page="' + n + '"' + (n === current ? ' aria-current="page"' : '') + '>' + n + '</button>';
      });
      html += '<button type="button" class="fnt-rv__page" data-rv-page="' + (current + 1) + '"' + (current === count ? ' disabled' : '') + ' aria-label="Página siguiente">›</button>';
      return html;
    }

    function draw(scroll) {
      var f = filters.filter(function (x) { return x.id === state.filter; })[0] || filters[0];
      var rows = pool.filter(f.test).slice();
      rows.sort(function (a, b) {
        if (state.sort === 'high') return b.stars - a.stars || b.time - a.time;
        if (state.sort === 'low') return a.stars - b.stars || b.time - a.time;
        return b.time - a.time;
      });

      var count = Math.max(1, Math.ceil(rows.length / perPage));
      state.page = Math.min(Math.max(1, state.page), count);
      var start = (state.page - 1) * perPage;

      list.innerHTML = rows.slice(start, start + perPage).map(itemHtml).join('');
      empty.hidden = rows.length > 0;
      pages.hidden = count < 2;
      pages.innerHTML = count < 2 ? '' : pageButtons(state.page, count);

      // "Leer más" solo si el texto está recortado
      list.querySelectorAll('.fnt-rv__item').forEach(function (li) {
        var text = li.querySelector('.fnt-rv__text');
        var btn = li.querySelector('.fnt-rv__readmore');
        if (text.scrollHeight > text.clientHeight + 2) btn.hidden = false;
      });

      // Al cambiar de página no se mueve la pantalla: la lista conserva su alto
      if (!scroll) list.style.minHeight = '';
    }

    pages.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rv-page]');
      if (!btn || btn.disabled) return;
      list.style.minHeight = list.offsetHeight + 'px';
      state.page = Number(btn.dataset.rvPage);
      draw(true);
    });

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.fnt-rv__readmore');
      if (!btn) return;
      var text = btn.previousElementSibling;
      var open = text.classList.toggle('is-open');
      btn.textContent = open ? 'Leer menos' : 'Leer más';
    });

    draw(false);
  }

  function init() {
    document.querySelectorAll('[data-fnt-rv]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
